import { Field, FastField } from 'formik';
import { Input } from '@chakra-ui/react';

import FormField from './FormField';

// If you need to extend Input functionality keep in mind that {...props} is on FormControl to support all Chakra props
// Specific props for Input should be excluded from ...props and manually added
const FormFieldComponent = ({ field, meta, type, placeholder, ...props }) => (
    <FormField name={field.name} isInvalid={meta.error && meta.touched} error={meta.error} {...props}>
        <Input
            {...field}
            type={type}
            placeholder={placeholder}
            // switching items quickly sometimes result in undefined value
            // zDefaultValue could be returned which means empty value
            value={field.value === undefined || field.value === 'zDefaultValue' ? '' : field.value}
        />
    </FormField>
);

const InputFormikField = ({ name, validate, isFastField = false, ...props }) => {
    return (
        <>
            {isFastField ? (
                <FastField name={name} validate={validate}>
                    {({ field, meta }) => <FormFieldComponent field={field} meta={meta} {...props} />}
                </FastField>
            ) : (
                <Field name={name} validate={validate}>
                    {({ field, meta }) => <FormFieldComponent field={field} meta={meta} {...props} />}
                </Field>
            )}
        </>
    );
};

export default InputFormikField;
